import React, { createContext, useContext, useEffect } from "react";
import { KeyedMutator } from "swr";
import { useAuthdAPI } from "../api";
import { DiscordUserResponse, UserMutate } from "../constants/types";
import { useErrorToast } from "../showToast";

export interface DiscordUserHook {
  user?: DiscordUserResponse | null;
  mutate: KeyedMutator<DiscordUserResponse | null | undefined>;
  isLoading: boolean;
}

export function useDiscordUser(): DiscordUserHook {
  const showErrorToast = useErrorToast();
  const {
    data: user,
    error,
    isValidating: isLoading,
    mutate,
  } = useAuthdAPI<DiscordUserResponse | null>("discord");

  useEffect(() => {
    if (error) {
      showErrorToast(error);
    }
  }, [error, showErrorToast]);

  return { user, mutate, isLoading };
}
